export const USER_LAYOUT_RECT_LEVEL = 9;
export const DEFAULT_LAYOUT_RECT_LEVEL = 0;
export const DEFAULT_LAYOUT_RECT_LEVEL_MIN = -1;
